"use client";

import { useLingui } from "@lingui/react";
import { baseUrl } from "@/utils/api-definition";
import { t } from "@lingui/macro";
import Image from "next/image";
import React from "react";
import Box from "@mui/material/Box";

export default function GiftBanner() {
  const { i18n } = useLingui();
  return (
    <div className="mb-2.5 mt-8 flex w-full justify-center text-sm">
      <Box
        sx={{
          maxWidth: "599px",
          maxHeight: "556px",
          width: { xs: "100%", sm: "90%", md: "100%", lg: "100%" },
          height: "100%",
          overflow: "hidden",
        }}
      >
        <Image
          loading="lazy"
          src={`${baseUrl}` + "/image/gift_images/gift_page/gift-page.png"}
          width={600}
          height={600}
          alt={t(i18n)`Design and give away vouchers yourself`}
          style={{
            objectFit: "contain",
            width: "100%",
            height: "100%",
          }}
        />
      </Box>
    </div>
  );
}
